import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { MerchantOperationRepository } from '@app/domain/ports/tpv/merchant-operation.repository';
import { TpvMerchantOperationResult } from '@app/domain/models/tpv/merchant-operation.model';
import {
  CreateMerchantOperationRequest,
  UpdateMerchantOperationRequest,
} from '@app/data/dtos/tpv/merchant-operation.dto';

/** Mock del CRUD de operación de comercio para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class MerchantOperationMockDataSource extends MerchantOperationRepository {
  override getOperation(externalIdMerchant: string): Observable<TpvMerchantOperationResult> {
    return of<TpvMerchantOperationResult>({
      idMerchant: externalIdMerchant,
      data: {
        transactional_schema: 'TRADICIONAL',
        afiliation_number: '1234567',
        subafiliation_number: '',
        mcc: '5411',
        acquirer_bank: 'BANORTE',
        logic_network: 'PROSA',
        aggregator: 'MEMPHIS',
        processor: 'BROXEL',
        register_token: 'mock-token',
        merchant_name: 'Comercio Mock',
      },
    }).pipe(delay(400));
  }

  override createOperation(
    externalIdMerchant: string,
    request: CreateMerchantOperationRequest,
    _idempotencyKey?: string,
  ): Observable<TpvMerchantOperationResult> {
    return of<TpvMerchantOperationResult>({
      idMerchant: externalIdMerchant,
      data: { id_merchant: externalIdMerchant, ...request },
    }).pipe(delay(500));
  }

  override updateOperation(
    externalIdMerchant: string,
    request: UpdateMerchantOperationRequest,
    _idempotencyKey?: string,
  ): Observable<TpvMerchantOperationResult> {
    return of<TpvMerchantOperationResult>({
      idMerchant: externalIdMerchant,
      data: { id_merchant: externalIdMerchant, ...request },
    }).pipe(delay(500));
  }

  override deleteOperation(_externalIdMerchant: string): Observable<void> {
    return of(undefined).pipe(delay(500));
  }
}
